/* BONEATO — animation du bouton panier à l'ajout (le tiroir ne s'ouvre plus sur un ajout).
   Écoute l'évènement "beo:cart-added" émis par beo-pdp.js (PDP/sticky/bundle) et par
   component-quick-buy.js (PLP/quick-add), puis joue un tilt d'icône + un pop du compteur
   sur TOUS les boutons panier (desktop .button--cart-handle + mobile .mobile-cart-button).
   Styles + keyframes : assets/beo-cart-feedback.css. */
(function () {
  "use strict";

  var BTN_SEL = ".button--cart-handle, .mobile-cart-button";
  var COUNT_SEL = "[data-header-cart-count]";
  var timer = null;

  function retrigger(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth; // reflow → permet de rejouer l'anim sur ajouts rapprochés
    el.classList.add(cls);
  }

  function play() {
    document.querySelectorAll(BTN_SEL).forEach(function (el) { retrigger(el, "beo-cart-bump"); });
    document.querySelectorAll(COUNT_SEL).forEach(function (el) { retrigger(el, "beo-count-pop"); });
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll(".beo-cart-bump").forEach(function (el) { el.classList.remove("beo-cart-bump"); });
      document.querySelectorAll(".beo-count-pop").forEach(function (el) { el.classList.remove("beo-count-pop"); });
    }, 550);
  }

  document.addEventListener("beo:cart-added", play);

  /* Resync de l'UI panier au retour bfcache (Précédent/Suivant).
     Le navigateur restaure un snapshot DOM figé : le JS n'est PAS rejoué et cart.js
     pas re-fetché, donc le compteur/total header + le tiroir gardent leur valeur du
     premier rendu serveur. On relit le panier via la section helper-cart (format money
     natif) et on met à jour le header + le corps du tiroir — même approche que l'ajout. */
  function resyncCart() {
    fetch("?section_id=helper-cart")
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var srcForm = doc.getElementById("AjaxCartForm"), dstForm = document.getElementById("AjaxCartForm");
        if (srcForm && dstForm) {
          dstForm.innerHTML = srcForm.innerHTML;
          if (typeof dstForm.ajaxifyCartItems === "function") { try { dstForm.ajaxifyCartItems(); } catch (e) {} }
        }
        var srcSub = doc.getElementById("AjaxCartSubtotal"), dstSub = document.getElementById("AjaxCartSubtotal");
        if (srcSub && dstSub) dstSub.innerHTML = srcSub.innerHTML;
        var c = doc.querySelector("[data-cart-count]"), t = doc.querySelector("[data-cart-total]");
        if (c) document.querySelectorAll("[data-header-cart-count]").forEach(function (el) { el.textContent = c.textContent.trim(); });
        if (t) document.querySelectorAll("[data-header-cart-total]").forEach(function (el) { el.textContent = t.textContent.trim(); });
      })["catch"](function () {});
  }

  /* Check léger : on relit cart.js (petit JSON) et on ne lance le resync lourd (helper-cart
     + tiroir) QUE si l'affiché diffère du serveur. Couvre tous les chemins de retour, pas
     seulement le bfcache strict (e.persisted) : back/forward sans persisted, et surtout les
     pages servies stale par instantpage (préchargement au survol). Idempotent → safe à
     appeler sur plusieurs évènements sans sur-fetch quand l'UI est déjà à jour. */
  function maybeResync() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var shown = document.querySelector("[data-header-cart-count]");
        var current = shown ? parseInt(shown.textContent, 10) : null;
        if (current !== cart.item_count) resyncCart(); // stale → resync complet (format natif + tiroir)
      })["catch"](function () {});
  }

  // pageshow couvre bfcache + chargement depuis cache prefetch ; popstate couvre tout back/forward.
  window.addEventListener("pageshow", maybeResync);
  window.addEventListener("popstate", maybeResync);
})();

/* ============================================================
   BONEATO, tache 1 (lot P1 app, 2026-09-07)
   Confirmation d'ajout SUR LA CARTE, pilotee par la vraie reponse API.

   Pourquoi ce bloc existe (etat des lieux avant) :
   - Le seul retour visible d'un ajout etait le tilt du chariot + le pop
     du compteur, dans le HEADER (bloc du dessus). Dans l'app, le header
     panier est remplace par la tab bar NATIVE de MobiLoud : ce retour
     est donc invisible cote app. D'ou « je tape, rien ne se passe ».
   - component-quick-buy.js posait bien un ✓ vert sur le « + », mais au
     CLIC, sans attendre la reponse : le ✓ s'affichait AUSSI quand
     l'ajout echouait (rupture de stock), et le bouton restait actif
     donc un double-tap envoyait deux requetes.
   - Piege a connaitre : sur un 422 (stock insuffisant),
     component-product-form.js dispatche QUAND MEME 'add-to-cart' apres
     avoir range l'alerte dans le tiroir panier, tiroir qui ne s'ouvre
     jamais sur la PLP (choix BEO). 'add-to-cart' ne veut donc PAS dire
     « succes » : on lit le statut HTTP reel nous-memes.

   Enchainement obtenu : tap -> etat « en cours » immediat (< 100 ms, pose
   au submit, avant tout reseau) + bouton desactive -> ✓ vert ~800 ms si
   l'API confirme, ou « ! » rouge ~1,6 s si elle refuse, puis retour a « + ».
   Styles : assets/beo-add-feedback.css (+ § 9b de beo-plp-redesign.css).
   ============================================================ */
(function () {
  "use strict";

  var PENDING = "beo-adding";
  var DONE = "beo-added";
  var FAILED = "beo-add-failed";
  var DONE_MS = 800;
  var FAILED_MS = 1600;
  var WATCHDOG_MS = 8000;

  // variantId -> file d'attente de boutons (FIFO). Permet de rattacher
  // chaque reponse au BON bouton meme si deux cartes sont tapees coup
  // sur coup : on identifie par l'id de variante envoye dans la requete.
  var pending = Object.create(null);

  /* --- 1. Lire le vrai resultat de /cart/add.js -------------------- */

  function variantFromBody(body) {
    if (typeof body !== "string") return "";
    var m = /(^|&)id=([^&]+)/.exec(body);
    return m ? decodeURIComponent(m[2]) : "";
  }

  function emit(variantId, ok) {
    document.dispatchEvent(new CustomEvent("beo:cart-add-result", {
      detail: { variantId: variantId, ok: !!ok }
    }));
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var method = ((init && init.method) || (input && input.method) || "GET").toUpperCase();
    var call = nativeFetch.apply(this, arguments);

    // On ne touche QU'aux POST vers /cart/add(.js) ; tout le reste
    // (sections, cart.js, recommandations…) passe inchange.
    if (method !== "POST" || url.indexOf("/cart/add") === -1) return call;

    var variantId = variantFromBody(init && init.body);

    return call.then(function (response) {
      // clone() : on lit le corps sans le consommer pour le theme.
      response.clone().json().then(function (data) {
        emit(variantId, response.ok && !(data && data.status === 422));
      })["catch"](function () {
        emit(variantId, response.ok);
      });
      return response;
    }, function (error) {
      emit(variantId, false); // reseau coupe / requete avortee
      throw error;
    });
  };

  /* --- 2. Etat du bouton ------------------------------------------- */

  function dropFromQueue(btn) {
    var q = pending[btn._beoVariant];
    if (!q) return;
    var i = q.indexOf(btn);
    if (i > -1) q.splice(i, 1);
  }

  function settle(btn, ok) {
    if (!btn._beoPending) return;
    btn._beoPending = false;
    clearTimeout(btn._beoTimer);
    dropFromQueue(btn);

    btn.disabled = false;
    btn.removeAttribute("aria-busy");
    btn.classList.remove(PENDING);
    btn.classList.add(ok ? DONE : FAILED);
    if (!ok) btn.setAttribute("title", "Could not add to cart, tap to try again");

    btn._beoTimer = setTimeout(function () {
      btn.classList.remove(DONE, FAILED);
      btn.removeAttribute("title");
    }, ok ? DONE_MS : FAILED_MS);
  }

  function start(btn, variantId) {
    if (btn._beoPending) return;
    btn._beoPending = true;
    btn._beoVariant = variantId;

    clearTimeout(btn._beoTimer);
    // Neutralise le ✓ optimiste historique de component-quick-buy.js :
    // il pose .beo-added des le clic et programme son retrait a 900 ms,
    // ce qui tronquait la vraie confirmation. On annule son minuteur
    // (stocke sur le bouton en _beoT) et on repart d'un etat propre.
    // Le handler d'origine devient inerte ; il reste en place pour ne
    // pas reecrire un fichier de theme entier a travers l'API (a
    // nettoyer plus tard, hors fenetre de soumission).
    clearTimeout(btn._beoT);
    btn.classList.remove(DONE, FAILED);
    btn.classList.add(PENDING);
    btn.setAttribute("aria-busy", "true");
    btn.removeAttribute("title");

    // Anti double-tap. On desactive DANS le handler de submit : le
    // theme a deja serialise le formulaire a ce stade (son listener est
    // sur le <form>, donc en phase cible, avant ce listener delegue), et
    // _serializeForm ignore de toute facon les <button type="submit">.
    // Desactiver plus tot (au clic) empecherait la soumission.
    btn.disabled = true;

    (pending[variantId] || (pending[variantId] = [])).push(btn);

    // Filet : si aucune reponse n'arrive (fetch remplace par un tiers,
    // requete avalee), on rend le bouton plutot que de le laisser mort.
    btn._beoTimer = setTimeout(function () { settle(btn, false); }, WATCHDOG_MS);
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || typeof form.querySelector !== "function") return;
    var btn = form.querySelector(".beo-add-btn");
    if (!btn) return;
    var idInput = form.querySelector('input[name="id"]');
    start(btn, idInput ? String(idInput.value) : "");
  });

  document.addEventListener("beo:cart-add-result", function (e) {
    var detail = e.detail || {};
    var queue = pending[detail.variantId];
    var btn = queue && queue.length ? queue[0] : null;
    if (btn) settle(btn, detail.ok);
  });
})();
